import {deleteRequest, get, post, put} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";


export const getPortfolioUserByStoreFilter = async (filter:any): Promise<DataResponse<any>> => {
  
  const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getPortfolioUserByStoreFilter}?${query?query:""}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const inviteUser = (data:any)=>{
    const url = `${endpoints.getPortfolioUserByStore}/${data.eMail}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, data,config);
  }

  export const getPortfolioUserByStore = async (storeId:string): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.getPortfolioUserByStore}/${storeId}`;
      const config = headers.content_type.application_json;
      return get<DataResponse<any>>(url, config);
    };
    export const getUserInfoesByPhoneNumber = async (numberPrefix:string,numberBody:string): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.getUserInfoesByPhoneNumber}/${numberPrefix}/${numberBody}`;
      const config = headers.content_type.application_json;
      return get<DataResponse<any>>(url, config);
    };

  export const addPortfolioUserByStore = async (data:any): Promise<DataResponse<any>> => {
  
      const url = `${endpoints.addPortfolioUserByStore}`;
      const config = headers.content_type.application_json;
      return post<DataResponse<any>>(url, data,config);
    };

    export const updatePortfolioUserByStore = async (data:any): Promise<DataResponse<any>> => {
  
      const url = `${endpoints.editPortfolioUserByStore}`;
      const config = headers.content_type.application_json;
      return put<DataResponse<any>>(url, data,config);
    };

    export const updatePortfolioUserByStoreList = async (data:any): Promise<DataResponse<any>> => {
  
      const url = `${endpoints.editPortfolioUserByStoreList}`;
      const config = headers.content_type.application_json;
      return put<DataResponse<any>>(url, data,config);
    };
    export const deletePortfolioUserByStore = async (data:any): Promise<DataResponse<any>> => {
  
      const url = `${endpoints.deletePortfolioUserByStore}/${data.userId}/${data?.storeId}`;
      const config = headers.content_type.application_json;
      return deleteRequest<DataResponse<any>>(url, data,config);
    };
  
  